import { createSelector } from 'reselect'

import { getCalculatedPercentValueDependOnSettings } from 'partner360/helpers/financialTable/getCalculatedPercentValueDependOnSettings'
import { getCalculatedValueDependOnSettings } from 'partner360/helpers/financialTable/getCalculatedValueDependOnSettings'
import { IQBRPlanAchievementDependOnSettings } from 'partner360/models/qbr/IQBRPlanAchievementDependOnSettings'

import { selectQbrState } from './selectQbrState'

export const selectPlanAchievementDependOnSettings = createSelector(
  [selectQbrState],
  ({ selectedDocument, documentSettings }) => {
    if (!selectedDocument) {
      return []
    }

    const planAchievement = selectedDocument.PlanAchievement
    const netNdp = documentSettings.netNdp
    const currency = documentSettings.currency
    const rounding = documentSettings.rounding
    const getValue = getCalculatedValueDependOnSettings({ currency, rounding, netNdp })
    const getPercent = getCalculatedPercentValueDependOnSettings({ currency, netNdp })
    return planAchievement.map<IQBRPlanAchievementDependOnSettings>((el) => {
      return {
        EntryId: el.EntryId,
        Name: el.Name,
        ParentId: el.ParentId || null,
        IsExpanded: el.IsExpanded,
        CurrentYearQ1Actuals: getValue(el, [
          'CurrentYearQ1ActualsNdpLocalCurrency',
          'CurrentYearQ1ActualsNdpUSD',
          'CurrentYearQ1ActualsNetLocalCurrency',
          'CurrentYearQ1ActualsNetUSD',
        ]),
        CurrentYearQ1ActualsUnits: el.CurrentYearQ1ActualsUnits,
        CurrentYearQ1Plans: getValue(el, [
          'CurrentYearQ1PlansNdpLocalCurrency',
          'CurrentYearQ1PlansNdpUSD',
          'CurrentYearQ1PlansNetLocalCurrency',
          'CurrentYearQ1PlansNetUSD',
        ]),
        CurrentYearQ1PlansUnits: el.CurrentYearQ1PlansUnits,
        CurrentYearQ1ActualsToPlans: getPercent(el, [
          'CurrentYearQ1ActualsToPlansNdpLocalCurrency',
          'CurrentYearQ1ActualsToPlansNdpUSD',
          'CurrentYearQ1ActualsToPlansNetLocalCurrency',
          'CurrentYearQ1ActualsToPlansNetUSD',
        ]),
        CurrentYearQ1ActualsToPlansUnits: el.CurrentYearQ1ActualsToPlansUnits,
        CurrentYearQ1YoYActuals: getPercent(el, [
          'CurrentYearQ1YoYActualsNdpLocalCurrency',
          'CurrentYearQ1YoYActualsNdpUSD',
          'CurrentYearQ1YoYActualsNetLocalCurrency',
          'CurrentYearQ1YoYActualsNetUSD',
        ]),
        CurrentYearQ1YoYActualsUnits: el.CurrentYearQ1YoYActualsUnits,
        CurrentYearQ1YoYPlans: getPercent(el, [
          'CurrentYearQ1YoYPlansNdpLocalCurrency',
          'CurrentYearQ1YoYPlansNdpUSD',
          'CurrentYearQ1YoYPlansNetLocalCurrency',
          'CurrentYearQ1YoYPlansNetUSD',
        ]),
        CurrentYearQ1YoYPlansUnits: el.CurrentYearQ1YoYPlansUnits,
        CurrentYearQ2Actuals: getValue(el, [
          'CurrentYearQ2ActualsNdpLocalCurrency',
          'CurrentYearQ2ActualsNdpUSD',
          'CurrentYearQ2ActualsNetLocalCurrency',
          'CurrentYearQ2ActualsNetUSD',
        ]),
        CurrentYearQ2ActualsUnits: el.CurrentYearQ2ActualsUnits,
        CurrentYearQ2Plans: getValue(el, [
          'CurrentYearQ2PlansNdpLocalCurrency',
          'CurrentYearQ2PlansNdpUSD',
          'CurrentYearQ2PlansNetLocalCurrency',
          'CurrentYearQ2PlansNetUSD',
        ]),
        CurrentYearQ2PlansUnits: el.CurrentYearQ2PlansUnits,
        CurrentYearQ2ActualsToPlans: getPercent(el, [
          'CurrentYearQ2ActualsToPlansNdpLocalCurrency',
          'CurrentYearQ2ActualsToPlansNdpUSD',
          'CurrentYearQ2ActualsToPlansNetLocalCurrency',
          'CurrentYearQ2ActualsToPlansNetUSD',
        ]),
        CurrentYearQ2ActualsToPlansUnits: el.CurrentYearQ2ActualsToPlansUnits,
        CurrentYearQ2YoYActuals: getPercent(el, [
          'CurrentYearQ2YoYActualsNdpLocalCurrency',
          'CurrentYearQ2YoYActualsNdpUSD',
          'CurrentYearQ2YoYActualsNetLocalCurrency',
          'CurrentYearQ2YoYActualsNetUSD',
        ]),
        CurrentYearQ2YoYActualsUnits: el.CurrentYearQ2YoYActualsUnits,
        CurrentYearQ2YoYPlans: getPercent(el, [
          'CurrentYearQ2YoYPlansNdpLocalCurrency',
          'CurrentYearQ2YoYPlansNdpUSD',
          'CurrentYearQ2YoYPlansNetLocalCurrency',
          'CurrentYearQ2YoYPlansNetUSD',
        ]),
        CurrentYearQ2YoYPlansUnits: el.CurrentYearQ2YoYPlansUnits,
        CurrentYearQ3Actuals: getValue(el, [
          'CurrentYearQ3ActualsNdpLocalCurrency',
          'CurrentYearQ3ActualsNdpUSD',
          'CurrentYearQ3ActualsNetLocalCurrency',
          'CurrentYearQ3ActualsNetUSD',
        ]),
        CurrentYearQ3ActualsUnits: el.CurrentYearQ3ActualsUnits,
        CurrentYearQ3Plans: getValue(el, [
          'CurrentYearQ3PlansNdpLocalCurrency',
          'CurrentYearQ3PlansNdpUSD',
          'CurrentYearQ3PlansNetLocalCurrency',
          'CurrentYearQ3PlansNetUSD',
        ]),
        CurrentYearQ3PlansUnits: el.CurrentYearQ3PlansUnits,
        CurrentYearQ3ActualsToPlans: getPercent(el, [
          'CurrentYearQ3ActualsToPlansNdpLocalCurrency',
          'CurrentYearQ3ActualsToPlansNdpUSD',
          'CurrentYearQ3ActualsToPlansNetLocalCurrency',
          'CurrentYearQ3ActualsToPlansNetUSD',
        ]),
        CurrentYearQ3ActualsToPlansUnits: el.CurrentYearQ3ActualsToPlansUnits,
        CurrentYearQ3YoYActuals: getPercent(el, [
          'CurrentYearQ3YoYActualsNdpLocalCurrency',
          'CurrentYearQ3YoYActualsNdpUSD',
          'CurrentYearQ3YoYActualsNetLocalCurrency',
          'CurrentYearQ3YoYActualsNetUSD',
        ]),
        CurrentYearQ3YoYActualsUnits: el.CurrentYearQ3YoYActualsUnits,
        CurrentYearQ3YoYPlans: getPercent(el, [
          'CurrentYearQ3YoYPlansNdpLocalCurrency',
          'CurrentYearQ3YoYPlansNdpUSD',
          'CurrentYearQ3YoYPlansNetLocalCurrency',
          'CurrentYearQ3YoYPlansNetUSD',
        ]),
        CurrentYearQ3YoYPlansUnits: el.CurrentYearQ3YoYPlansUnits,
        CurrentYearQ4Actuals: getValue(el, [
          'CurrentYearQ4ActualsNdpLocalCurrency',
          'CurrentYearQ4ActualsNdpUSD',
          'CurrentYearQ4ActualsNetLocalCurrency',
          'CurrentYearQ4ActualsNetUSD',
        ]),
        CurrentYearQ4ActualsUnits: el.CurrentYearQ4ActualsUnits,
        CurrentYearQ4Plans: getValue(el, [
          'CurrentYearQ4PlansNdpLocalCurrency',
          'CurrentYearQ4PlansNdpUSD',
          'CurrentYearQ4PlansNetLocalCurrency',
          'CurrentYearQ4PlansNetUSD',
        ]),
        CurrentYearQ4PlansUnits: el.CurrentYearQ4PlansUnits,
        CurrentYearQ4ActualsToPlans: getPercent(el, [
          'CurrentYearQ4ActualsToPlansNdpLocalCurrency',
          'CurrentYearQ4ActualsToPlansNdpUSD',
          'CurrentYearQ4ActualsToPlansNetLocalCurrency',
          'CurrentYearQ4ActualsToPlansNetUSD',
        ]),
        CurrentYearQ4ActualsToPlansUnits: el.CurrentYearQ4ActualsToPlansUnits,
        CurrentYearQ4YoYActuals: getPercent(el, [
          'CurrentYearQ4YoYActualsNdpLocalCurrency',
          'CurrentYearQ4YoYActualsNdpUSD',
          'CurrentYearQ4YoYActualsNetLocalCurrency',
          'CurrentYearQ4YoYActualsNetUSD',
        ]),
        CurrentYearQ4YoYActualsUnits: el.CurrentYearQ4YoYActualsUnits,
        CurrentYearQ4YoYPlans: getPercent(el, [
          'CurrentYearQ4YoYPlansNdpLocalCurrency',
          'CurrentYearQ4YoYPlansNdpUSD',
          'CurrentYearQ4YoYPlansNetLocalCurrency',
          'CurrentYearQ4YoYPlansNetUSD',
        ]),
        CurrentYearQ4YoYPlansUnits: el.CurrentYearQ4YoYPlansUnits,
        CurrentYearFYActuals: getValue(el, [
          'CurrentYearFYActualsNdpLocalCurrency',
          'CurrentYearFYActualsNdpUSD',
          'CurrentYearFYActualsNetLocalCurrency',
          'CurrentYearFYActualsNetUSD',
        ]),
        CurrentYearFYActualsUnits: el.CurrentYearFYActualsUnits,
        CurrentYearFYPlans: getValue(el, [
          'CurrentYearFYPlansNdpLocalCurrency',
          'CurrentYearFYPlansNdpUSD',
          'CurrentYearFYPlansNetLocalCurrency',
          'CurrentYearFYPlansNetUSD',
        ]),
        CurrentYearFYPlansUnits: el.CurrentYearFYPlansUnits,
        CurrentYearFYActualsToPlans: getPercent(el, [
          'CurrentYearFYActualsToPlansNdpLocalCurrency',
          'CurrentYearFYActualsToPlansNdpUSD',
          'CurrentYearFYActualsToPlansNetLocalCurrency',
          'CurrentYearFYActualsToPlansNetUSD',
        ]),
        CurrentYearFYActualsToPlansUnits: el.CurrentYearFYActualsToPlansUnits,
        CurrentYearFYYoYActuals: getPercent(el, [
          'CurrentYearFYYoYActualsNdpLocalCurrency',
          'CurrentYearFYYoYActualsNdpUSD',
          'CurrentYearFYYoYActualsNetLocalCurrency',
          'CurrentYearFYYoYActualsNetUSD',
        ]),
        CurrentYearFYYoYActualsUnits: el.CurrentYearFYYoYActualsUnits,
        CurrentYearFYYoYPlans: getPercent(el, [
          'CurrentYearFYYoYPlansNdpLocalCurrency',
          'CurrentYearFYYoYPlansNdpUSD',
          'CurrentYearFYYoYPlansNetLocalCurrency',
          'CurrentYearFYYoYPlansNetUSD',
        ]),
        CurrentYearFYYoYPlansUnits: el.CurrentYearFYYoYPlansUnits,
        PrevYearQ1Actuals: getValue(el, [
          'PrevYearQ1ActualsNdpLocalCurrency',
          'PrevYearQ1ActualsNdpUSD',
          'PrevYearQ1ActualsNetLocalCurrency',
          'PrevYearQ1ActualsNetUSD',
        ]),
        PrevYearQ1ActualsUnits: el.PrevYearQ1ActualsUnits,
        PrevYearQ1Plans: getValue(el, [
          'PrevYearQ1PlansNdpLocalCurrency',
          'PrevYearQ1PlansNdpUSD',
          'PrevYearQ1PlansNetLocalCurrency',
          'PrevYearQ1PlansNetUSD',
        ]),
        PrevYearQ1PlansUnits: el.PrevYearQ1PlansUnits,
        PrevYearQ1ActualsToPlans: getPercent(el, [
          'PrevYearQ1ActualsToPlansNdpLocalCurrency',
          'PrevYearQ1ActualsToPlansNdpUSD',
          'PrevYearQ1ActualsToPlansNetLocalCurrency',
          'PrevYearQ1ActualsToPlansNetUSD',
        ]),
        PrevYearQ1ActualsToPlansUnits: el.PrevYearQ1ActualsToPlansUnits,
        PrevYearQ1YoYActuals: getPercent(el, [
          'PrevYearQ1YoYActualsNdpLocalCurrency',
          'PrevYearQ1YoYActualsNdpUSD',
          'PrevYearQ1YoYActualsNetLocalCurrency',
          'PrevYearQ1YoYActualsNetUSD',
        ]),
        PrevYearQ1YoYActualsUnits: el.PrevYearQ1YoYActualsUnits,
        PrevYearQ1YoYPlans: getPercent(el, [
          'PrevYearQ1YoYPlansNdpLocalCurrency',
          'PrevYearQ1YoYPlansNdpUSD',
          'PrevYearQ1YoYPlansNetLocalCurrency',
          'PrevYearQ1YoYPlansNetUSD',
        ]),
        PrevYearQ1YoYPlansUnits: el.PrevYearQ1YoYPlansUnits,
        PrevYearQ2Actuals: getValue(el, [
          'PrevYearQ2ActualsNdpLocalCurrency',
          'PrevYearQ2ActualsNdpUSD',
          'PrevYearQ2ActualsNetLocalCurrency',
          'PrevYearQ2ActualsNetUSD',
        ]),
        PrevYearQ2ActualsUnits: el.PrevYearQ2ActualsUnits,
        PrevYearQ2Plans: getValue(el, [
          'PrevYearQ2PlansNdpLocalCurrency',
          'PrevYearQ2PlansNdpUSD',
          'PrevYearQ2PlansNetLocalCurrency',
          'PrevYearQ2PlansNetUSD',
        ]),
        PrevYearQ2PlansUnits: el.PrevYearQ2PlansUnits,
        PrevYearQ2ActualsToPlans: getPercent(el, [
          'PrevYearQ2ActualsToPlansNdpLocalCurrency',
          'PrevYearQ2ActualsToPlansNdpUSD',
          'PrevYearQ2ActualsToPlansNetLocalCurrency',
          'PrevYearQ2ActualsToPlansNetUSD',
        ]),
        PrevYearQ2ActualsToPlansUnits: el.PrevYearQ2ActualsToPlansUnits,
        PrevYearQ2YoYActuals: getPercent(el, [
          'PrevYearQ2YoYActualsNdpLocalCurrency',
          'PrevYearQ2YoYActualsNdpUSD',
          'PrevYearQ2YoYActualsNetLocalCurrency',
          'PrevYearQ2YoYActualsNetUSD',
        ]),
        PrevYearQ2YoYActualsUnits: el.PrevYearQ2YoYActualsUnits,
        PrevYearQ2YoYPlans: getPercent(el, [
          'PrevYearQ2YoYPlansNdpLocalCurrency',
          'PrevYearQ2YoYPlansNdpUSD',
          'PrevYearQ2YoYPlansNetLocalCurrency',
          'PrevYearQ2YoYPlansNetUSD',
        ]),
        PrevYearQ2YoYPlansUnits: el.PrevYearQ2YoYPlansUnits,
        PrevYearQ3Actuals: getValue(el, [
          'PrevYearQ3ActualsNdpLocalCurrency',
          'PrevYearQ3ActualsNdpUSD',
          'PrevYearQ3ActualsNetLocalCurrency',
          'PrevYearQ3ActualsNetUSD',
        ]),
        PrevYearQ3ActualsUnits: el.PrevYearQ3ActualsUnits,
        PrevYearQ3Plans: getValue(el, [
          'PrevYearQ3PlansNdpLocalCurrency',
          'PrevYearQ3PlansNdpUSD',
          'PrevYearQ3PlansNetLocalCurrency',
          'PrevYearQ3PlansNetUSD',
        ]),
        PrevYearQ3PlansUnits: el.PrevYearQ3PlansUnits,
        PrevYearQ3ActualsToPlans: getPercent(el, [
          'PrevYearQ3ActualsToPlansNdpLocalCurrency',
          'PrevYearQ3ActualsToPlansNdpUSD',
          'PrevYearQ3ActualsToPlansNetLocalCurrency',
          'PrevYearQ3ActualsToPlansNetUSD',
        ]),
        PrevYearQ3ActualsToPlansUnits: el.PrevYearQ3ActualsToPlansUnits,
        PrevYearQ3YoYActuals: getPercent(el, [
          'PrevYearQ3YoYActualsNdpLocalCurrency',
          'PrevYearQ3YoYActualsNdpUSD',
          'PrevYearQ3YoYActualsNetLocalCurrency',
          'PrevYearQ3YoYActualsNetUSD',
        ]),
        PrevYearQ3YoYActualsUnits: el.PrevYearQ3YoYActualsUnits,
        PrevYearQ3YoYPlans: getPercent(el, [
          'PrevYearQ3YoYPlansNdpLocalCurrency',
          'PrevYearQ3YoYPlansNdpUSD',
          'PrevYearQ3YoYPlansNetLocalCurrency',
          'PrevYearQ3YoYPlansNetUSD',
        ]),
        PrevYearQ3YoYPlansUnits: el.PrevYearQ3YoYPlansUnits,
        PrevYearQ4Actuals: getValue(el, [
          'PrevYearQ4ActualsNdpLocalCurrency',
          'PrevYearQ4ActualsNdpUSD',
          'PrevYearQ4ActualsNetLocalCurrency',
          'PrevYearQ4ActualsNetUSD',
        ]),
        PrevYearQ4ActualsUnits: el.PrevYearQ4ActualsUnits,
        PrevYearQ4Plans: getValue(el, [
          'PrevYearQ4PlansNdpLocalCurrency',
          'PrevYearQ4PlansNdpUSD',
          'PrevYearQ4PlansNetLocalCurrency',
          'PrevYearQ4PlansNetUSD',
        ]),
        PrevYearQ4PlansUnits: el.PrevYearQ4PlansUnits,
        PrevYearQ4ActualsToPlans: getPercent(el, [
          'PrevYearQ4ActualsToPlansNdpLocalCurrency',
          'PrevYearQ4ActualsToPlansNdpUSD',
          'PrevYearQ4ActualsToPlansNetLocalCurrency',
          'PrevYearQ4ActualsToPlansNetUSD',
        ]),
        PrevYearQ4ActualsToPlansUnits: el.PrevYearQ4ActualsToPlansUnits,
        PrevYearQ4YoYActuals: getPercent(el, [
          'PrevYearQ4YoYActualsNdpLocalCurrency',
          'PrevYearQ4YoYActualsNdpUSD',
          'PrevYearQ4YoYActualsNetLocalCurrency',
          'PrevYearQ4YoYActualsNetUSD',
        ]),
        PrevYearQ4YoYActualsUnits: el.PrevYearQ4YoYActualsUnits,
        PrevYearQ4YoYPlans: getPercent(el, [
          'PrevYearQ4YoYPlansNdpLocalCurrency',
          'PrevYearQ4YoYPlansNdpUSD',
          'PrevYearQ4YoYPlansNetLocalCurrency',
          'PrevYearQ4YoYPlansNetUSD',
        ]),
        PrevYearQ4YoYPlansUnits: el.PrevYearQ4YoYPlansUnits,
        PrevYearFYActuals: getValue(el, [
          'PrevYearFYActualsNdpLocalCurrency',
          'PrevYearFYActualsNdpUSD',
          'PrevYearFYActualsNetLocalCurrency',
          'PrevYearFYActualsNetUSD',
        ]),
        PrevYearFYActualsUnits: el.PrevYearFYActualsUnits,
        PrevYearFYPlans: getValue(el, [
          'PrevYearFYPlansNdpLocalCurrency',
          'PrevYearFYPlansNdpUSD',
          'PrevYearFYPlansNetLocalCurrency',
          'PrevYearFYPlansNetUSD',
        ]),
        PrevYearFYPlansUnits: el.PrevYearFYPlansUnits,
        PrevYearFYActualsToPlans: getPercent(el, [
          'PrevYearFYActualsToPlansNdpLocalCurrency',
          'PrevYearFYActualsToPlansNdpUSD',
          'PrevYearFYActualsToPlansNetLocalCurrency',
          'PrevYearFYActualsToPlansNetUSD',
        ]),
        PrevYearFYActualsToPlansUnits: el.PrevYearFYActualsToPlansUnits,
        PrevYearFYYoYActuals: getPercent(el, [
          'PrevYearFYYoYActualsNdpLocalCurrency',
          'PrevYearFYYoYActualsNdpUSD',
          'PrevYearFYYoYActualsNetLocalCurrency',
          'PrevYearFYYoYActualsNetUSD',
        ]),
        PrevYearFYYoYActualsUnits: el.PrevYearFYYoYActualsUnits,
        PrevYearFYYoYPlans: getPercent(el, [
          'PrevYearFYYoYPlansNdpLocalCurrency',
          'PrevYearFYYoYPlansNdpUSD',
          'PrevYearFYYoYPlansNetLocalCurrency',
          'PrevYearFYYoYPlansNetUSD',
        ]),
        PrevYearFYYoYPlansUnits: el.PrevYearFYYoYPlansUnits,
        PrevYearTFYActuals: getValue(el, [
          'PrevYearTFYActualsNdpLocalCurrency',
          'PrevYearTFYActualsNdpUSD',
          'PrevYearTFYActualsNetLocalCurrency',
          'PrevYearTFYActualsNetUSD',
        ]),
        PrevYearTFYActualsUnits: el.PrevYearTFYActualsUnits,
        PrevYearTFYPlans: getValue(el, [
          'PrevYearTFYPlansNdpLocalCurrency',
          'PrevYearTFYPlansNdpUSD',
          'PrevYearTFYPlansNetLocalCurrency',
          'PrevYearTFYPlansNetUSD',
        ]),
        PrevYearTFYPlansUnits: el.PrevYearTFYPlansUnits,
        PrevYearTFYActualsToPlans: getPercent(el, [
          'PrevYearTFYActualsToPlansNdpLocalCurrency',
          'PrevYearTFYActualsToPlansNdpUSD',
          'PrevYearTFYActualsToPlansNetLocalCurrency',
          'PrevYearTFYActualsToPlansNetUSD',
        ]),
        PrevYearTFYActualsToPlansUnits: el.PrevYearTFYActualsToPlansUnits,
        PrevYearTFYYoYActuals: getPercent(el, [
          'PrevYearTFYYoYActualsNdpLocalCurrency',
          'PrevYearTFYYoYActualsNdpUSD',
          'PrevYearTFYYoYActualsNetLocalCurrency',
          'PrevYearTFYYoYActualsNetUSD',
        ]),
        PrevYearTFYYoYActualsUnits: el.PrevYearTFYYoYActualsUnits,
        PrevYearTFYYoYPlans: getPercent(el, [
          'PrevYearTFYYoYPlansNdpLocalCurrency',
          'PrevYearTFYYoYPlansNdpUSD',
          'PrevYearTFYYoYPlansNetLocalCurrency',
          'PrevYearTFYYoYPlansNetUSD',
        ]),
        PrevYearTFYYoYPlansUnits: el.PrevYearTFYYoYPlansUnits,
      }
    })
  }
)
